import { Table } from "antd";

import EmployeeProfile from "@/components/cards/EmployeeProfile";

// Таблица участников РГ
// Содержит список. Тут можно настроить колонки
const UnitMembersTable = ({ data, scroll = { x: "100%" }, loading }) => {
  const columns = [
    {
      title: "Имя",
      dataIndex: "name",
      key: "name",
      ellipsis: {
        showTitle: false,
      },
      fixed: "left",
      render: (_, member) => <EmployeeProfile {...member} />,
    },
    {
      title: "Должность",
      dataIndex: "position_name",
      key: "position_name",
      ellipsis: {
        showTitle: false,
      },
    },
    {
      title: "Контактные данные",
      dataIndex: "phone",
      key: "phone",
      ellipsis: {
        showTitle: false,
      },
    },
    // {
    //   title: "Email",
    //   dataIndex: "secondary_email",
    //   key: "secondary_email",
    //   ellipsis: {
    //     showTitle: false,
    //   },
    // },
  ];

  return (
    <>
      <Table
        dataSource={data}
        columns={columns}
        rowKey="uuid"
        loading={loading}
        pagination={false}
        showSorterTooltip={{
          target: "sorter-icon",
          title: "Нажмите для сортировки",
        }}
        scroll={scroll}
      />
    </>
  );
};

export default UnitMembersTable;
